import {Component, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-pdf-pagebreak',
    templateUrl: './pdf-pagebreak.component.html',
    styleUrls: ['./pdf-pagebreak.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfPagebreakComponent {

}
